export default __webpack_public_path__ + "static/media/discord-icon-comm.44d047fe.png";